<template>
  <el-container v-loading="loading" id="top" style="height:969px;">
    <el-header>
      <HeaderView :userName="viewUserName" @calcHeaderSpace="calcHeaderSpace" />
    </el-header>
    <el-container>
      <el-container id="submenu" style="height:100%;overflow:auto;">
        <el-aside>
          <MenuView :cowMenuRadio="cow_menu_radio" :isAdmin="isAdmin" :userType="userType" :farmerId="farmer_id" />
        </el-aside>
      </el-container>
      <el-container id="sub" style="overflow:auto;">
        <el-main>
          <!-- 一覧表示 -->
          <div v-if="!select_user_id">
            <div>
              <el-row :gutter="20" style="justify-content: right;padding-top: 1em;">
                <el-col :span="3" style="min-width:140px;">
                  <div>
                    <el-button color="#EEEEEC" style="color: #383838;" type="primary" class="operation-btn"
                      @click="filterClear(); setFilter(); editNew()">
                      <el-icon style="color: #383838; padding-right: 1em;">
                        <IconPlus />
                      </el-icon>新規登録
                    </el-button>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div></div>
                </el-col>
                <el-col :span="3" style="min-width:140px;">
                  <div>
                    <el-button color="#EEEEEC" style="color: #383838;" type="primary" class="operation-btn"
                      @click="filterDialogOpen()">
                      <el-icon :style="{ color: icon_color, paddingRight: '1em' }">
                        <IconAdjustment />
                      </el-icon>絞り込み
                    </el-button>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="display:flex;">
                    <el-input v-model="search_text" v-on:keydown.enter="filterUpdate()" :prefix-icon="IconMagnifyingGlass"
                      :suffix-icon="IconClear" :maxlength="maxLength" style="height:50px;min-width:164px;" />
                    <div style="width:0px;position:relative;">
                      <el-button type="primary" @click="search_text = ''"
                        style="position:absolute;left:-33px;top:0px;height:50px;opacity:0;" />
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row style="justify-content: right; padding-top: 5px; padding-bottom: 5px;">
                <el-button v-if="filter_admin" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                  @click="filterDisable(1)">管理者<el-icon>
                    <IconClear />
                  </el-icon></el-button>
                <el-button v-if="filter_helper" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                  @click="filterDisable(2)">協力者<el-icon>
                    <IconClear />
                  </el-icon></el-button>
                <el-button v-if="filter_veterinarian" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                  @click="filterDisable(3)">獣医<el-icon>
                    <IconClear />
                  </el-icon></el-button>
                <el-button v-if="filter_demouser" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                  @click="filterDisable(4)">デモユーザー<el-icon>
                    <IconClear />
                  </el-icon></el-button>
              </el-row>
            </div>
            <el-table v-if="!loading" :data="tableUserData" stripe style="height:600px;width:100%;"
              @row-click="selectUser">
              <el-table-column label="" :width="headerWidth" />
              <el-table-column prop="name" label="氏名" />
              <el-table-column prop="farmer" label="農家ID" />
              <el-table-column prop="kind">
                <template #header>
                  <label>権限</label>
                  <el-button class="link-icon" link :icon="sortIcons[0]" @click="sortSetting(0)"></el-button>
                </template>
              </el-table-column>
              <el-table-column prop="email" label="メールアドレス" />
            </el-table>
            <el-dialog v-model="userSelectFilterDialog" title="ユーザー絞り込み" width="400px">
              <el-row></el-row>
              <el-row>
                <el-col :span="12">
                  <span>権限</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_admin" label="管理者" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_helper" label="協力者" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_veterinarian" label="獣医" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_demouser" label="デモユーザー" size="large" />
                </el-col>
              </el-row>
              <template #footer>
                <el-row style="justify-content: center;">
                  <el-button round style="color: #383838; background: #FFFFFF;" @click="filterClear()">クリア</el-button>
                  <el-button round style="color: #383838; background: #ffdf5e;" @click="setFilter()">絞り込み</el-button>
                </el-row>
              </template>
            </el-dialog>
          </div>
          <!-- 詳細表示 -->
          <div v-if="select_user_id !== '' & select_user_id !== '新規登録' & !user_edit">
            <el-row :gutter="20" style="justify-content: right;padding-top: 1em;">
              <el-col :span="3">
                <div>
                  <el-button color="#EEEEEC" style="color: #383838;" type="primary" class="operation-btn"
                    @click="saveUserName = select_user_name; select_user_name = ''; user_edit = true">
                    <el-icon style="color: #383838; padding-right: 1em;">
                      <IconPencil />
                    </el-icon>編集
                  </el-button>
                </div>
              </el-col>
              <el-col :span="12"></el-col>
              <el-col :span="3"></el-col>
              <el-col :span="6"></el-col>
            </el-row>
            <el-row>
              <div style="color:#383838;background:#F8F8F7;border-radius:8px;width:1470px;height:210px;margin-top:15px;">
                <el-row :gutter="20" style="padding-top: 1em;padding-left: 1em;">ユーザー情報</el-row>
                <el-row style="margin-top: 15px;">
                  <el-col :span="6" style="margin-top: 0px;">
                    <el-row class="padding-left-2">名前</el-row>
                    <el-row class="padding-left-2">
                      <p class="font-bold">{{ select_user_name }}</p>
                    </el-row>
                  </el-col>
                  <el-col :span="6" style="margin-top: 0px;">
                    <el-row class="padding-left-2">農家ID</el-row>
                    <el-row class="padding-left-2">
                      <p class="font-bold">{{ select_user_farmer_id }}</p>
                    </el-row>
                  </el-col>
                  <el-col :span="6" style="margin-top: 0px;">
                    <el-row class="padding-left-2">権限</el-row>
                    <el-row class="padding-left-2">
                      <p class="font-bold">{{ user_kinds[select_user_kind] }}</p>
                    </el-row>
                  </el-col>
                  <el-col :span="6" style="margin-top: 0px;">
                    <el-row class="padding-left-2">メールアドレス</el-row>
                    <el-row class="padding-left-2">
                      <p class="font-bold">{{ select_user_email }}</p>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-row>
          </div>
          <!-- 編集 -->
          <div v-if="select_user_id !== '' & user_edit">
            <el-row :gutter="20" style="justify-content: left;padding-top: 1em;">
              <div style="color:#383838;background:#F8F8F7;border-radius:8px;width:1470px;height:210px;margin-top:15px;">
                <el-row style="padding-top: 1em;padding-left: 1em;">ユーザー情報</el-row>
                <el-row style="margin-top: 15px;">
                  <el-col :span="6" style="margin-top: 0px;">
                    <el-row class="padding-left-2">名前</el-row>
                    <el-row class="padding-left-2"><el-input v-model="select_user_name" style="width:180px"
                        :maxlength="maxLength" /></el-row>
                  </el-col>
                  <el-col :span="6" style="margin-top: 0px;">
                    <el-row class="padding-left-2">農家ID</el-row>
                    <el-row class="padding-left-2"><span>{{ select_user_farmer_id }}</span></el-row>
                  </el-col>
                  <el-col :span="6" style="margin-top: 0px;">
                    <el-row class="padding-left-2">権限</el-row>
                    <el-row class="padding-left-2">
                      <el-select id="select_user_kind" placeholder="" v-model="select_user_kind" style="width:180px">
                        <el-option v-for="user_kind in this.user_kinds_select" :key="user_kind.id" :label="user_kind.kind"
                          :value="user_kind.id" />
                      </el-select>
                    </el-row>
                  </el-col>
                  <el-col :span="6" style="margin-top: 0px;">
                    <el-row class="padding-left-2">メールアドレス</el-row>
                    <el-row class="padding-left-2">
                      <el-input v-if="select_user_id === '新規登録'" v-model="select_user_email" style="width:300px"
                        :maxlength="maxLength" />
                      <span v-if="select_user_id !== '新規登録'">{{ select_user_email }}</span>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-row>
          </div>
        </el-main>
        <el-footer style="overflow:hidden;background:white;paddingTop:4px;width:100%">
          <el-row v-if="select_user_id !== '' & select_user_id !== '新規登録' & !user_edit">
            <el-col :span="11" />
            <el-col :span="5">
              <el-button class="button-style" color="#EEEEEC" style="width:214px;" round type="primary"
                @click="filterClear(); setFilter(); select_user_id = ''">戻る</el-button>
            </el-col>
          </el-row>
          <el-row v-if="user_edit">
            <el-col :span="7" />
            <el-col :span="5">
              <el-button class="button-style" color="#EEEEEC" style="width:214px;" round type="primary"
                @click="select_user_name = saveUserName; editCancel()">キャンセル</el-button>
            </el-col>
            <el-col :span="5">
              <el-button class="button-style" color="#ffdf5e" style="width:214px;" round type="primary"
                @click="user_entry()">保存</el-button>
            </el-col>
            <el-col :span="5" />
            <el-col :span="2" v-if="select_user_id !== '新規登録'">
              <el-button class="button-style" color="#EEEEEC" style="width:75px;" round type="primary"
                @click="delete_user()">
                <el-icon style="color: #383838; padding-right: 0.5em;">
                  <IconTrash />
                </el-icon>削除
              </el-button>
            </el-col>
          </el-row>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import HeaderView from '../components/HeaderView';
import MenuView from '../components/MenuView';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getCurrentUser, signout } from "./js/cognito";
import AWSAPI from './js/aws-api';
import { ElMessage } from 'element-plus';
import ConstParam from './js/const';
import rsa from 'js-crypto-rsa';
import keyutil from 'js-crypto-key-utils'
import aes from 'js-crypto-aes';
import random from 'js-crypto-random'
import { shallowRef } from 'vue';
import * as icons from '../components/icons/modules'
import { sortBy } from 'lodash';

// ロケール設定・タイムゾーン設定
dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

// 定数定義
const colorYellow = "#FFB600";
const colorNormal = "#383838";

export default {
  name: 'UserManageView',
  components: {
    HeaderView,
    MenuView
  },
  created() {
    this.$store.commit('setCowMenuSelect', 'ユーザー管理');
  },
  mounted() {
    this.restore_param();
    this.generateKeys();
    this.get_current_user();
  },
  data() {
    return {
      saveUserName: "",
      userType: -1,
      headerWidth: "96px",
      sortLevel: [0],
      sortIndex: -1,
      sortIconNames: ["IconArrowUpDown1", "IconArrowUpDown2", "IconArrowUpDown3"],
      sortIcons: ["IconArrowUpDown1"],
      sortNames: ["kind"],
      IconArrowUpDown1: shallowRef(icons.IconArrowUpDown1),
      IconArrowUpDown2: shallowRef(icons.IconArrowUpDown2),
      IconArrowUpDown3: shallowRef(icons.IconArrowUpDown3),
      IconPlus: shallowRef(icons.IconPlus),
      IconPencil: shallowRef(icons.IconPencil),
      IconAdjustment: shallowRef(icons.IconAdjustment),
      IconMagnifyingGlass: shallowRef(icons.IconMagnifyingGlass),
      IconClear: shallowRef(icons.IconClear),
      IconTrash: shallowRef(icons.IconTrash),
      maxLength: ConstParam.maxLength,
      // 暗号化
      apiRetry: false,
      decUsersRetry: false,
      publicKey_base64: null,
      privateKey_jwk: null,
      commonKey: null,
      commonKey_base64: null,
      commonKey_crypt: null,
      commonKey_time: 0,
      usersDataEnc: {},
      // ダイアログ変数
      userSelectFilterDialog: false,
      // フィルター変数
      icon_color: colorNormal,
      filter_admin: false,
      filter_helper: false,
      filter_veterinarian: false,
      filter_demouser: false,
      // フィルターワーク
      dialog_admin: false,
      dialog_helper: false,
      dialog_veterinarian: false,
      dialog_demouser: false,
      // その他
      listData: {},
      search_text: "",
      usersData: {},
      tableUserData: [],
      orgTableUserData: [],
      // 詳細表示用
      select_user_id: "",
      select_user_name: "",
      select_user_farmer_id: "",
      select_user_kind: 0,
      select_user_email: "",
      save_user_name: "",
      save_user_farmer_id: "",
      save_user_kind: "",
      save_user_email: "",
      user_edit: false,
      user_kinds_select: ConstParam.user_kinds_select,
      user_kinds: ConstParam.user_kinds,
      // ===== 以降固定 ====
      isAdmin: false,
      cow_menu_radio: "",
      column_number: 3, // 一覧カラム数
      loading: false,
      userData: {},
      farmer_id: "",
      viewUserName: "",
      viewFarmerName: "",
      logOut: false,
      // ==================
      // 以降の要否は要確認
      selectCamera: "",
      view_mode: ""
    }
  },
  methods: {
    getErrorMessage(res) {
      if (
        'message' in res &&
        'response' in res.message &&
        'data' in res.message.response &&
        'message' in res.message.response.data
      ) {
        return res.message.response.data.message
      } else {
        return ""
      }
    },
    calcHeaderSpace(spacesize) {
      this.headerWidth = spacesize;
    },
    sortSetting(index) {
      this.sortIndex = index;
      this.tableUserData = [];
      for (let idx = 0; idx < this.sortLevel.length; idx++) {
        if (idx == index) {
          this.sortLevel[idx] = (this.sortLevel[idx] + 1) % 3;
        } else {
          this.sortLevel[idx] = 0;
        }
        this.sortIcons[idx] = this.sortIconNames[this.sortLevel[idx]];
      }
      // フィルター再適用
      this.filterUpdate();
    },
    generateKeys() {
      rsa.generateKey(2048).then((key) => {
        this.privateKey_jwk = key.privateKey;
        const keyObj = new keyutil.Key('jwk', key.publicKey);
        this.exportKey(keyObj);
      })
    },
    async exportKey(keyObj) {
      let der
      der = await keyObj.export('der')
      this.publicKey_base64 = Buffer.from(der).toString('base64')
      this.getCommonKey(this.publicKey_base64)
    },
    getCommonKey(pubKey) {
      AWSAPI.getCommonKey(pubKey)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.commonKey_base64 = res.data.data[0]['common_key'];
            this.commonKey_time = res.data.data[0]['created_at'];
            this.commonKey_crypt = Buffer.from(this.commonKey_base64, "base64");
            rsa.decrypt(
              this.commonKey_crypt,
              this.privateKey_jwk,
              'SHA-512'
            ).then((decrypted) => {
              this.commonKey = decrypted
            })
          }
        })
    },
    itemCheckUser(isUpdate) {
      if (this.select_user_name === "") {
        this.viewMessage("『ユーザー名』は必須入力項目です。", "error");
        return false;
      }
      if (!isUpdate && this.select_user_email === "") {
        this.viewMessage("『ｅメール』は必須入力項目です。", "error");
        return false;
      }
      return true;
    },
    user_entry() {
      if (this.select_user_id === '新規登録') {
        this.add_user();
      } else {
        this.update_user();
      }
    },
    add_user() {
      // 新規登録
      let isUpdate = false;
      if (!this.itemCheckUser(isUpdate)) {
        return;
      }
      let message = "ユーザー『" + this.select_user_name + "』を追加しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '追加',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.add_user_sub();
      }).catch(() => {
        return
      });
    },
    add_user_sub: async function () {
      // 暗号化
      let tempJson = JSON.stringify(
        {
          farmer_id: this.farmer_id,
          email: this.select_user_email,
          user_name: this.select_user_name,
          user_type: this.select_user_kind
        }
      )
      let tempJson_bin = (new TextEncoder).encode(tempJson)
      let iv = random.getRandomBytes(16)
      // api('add_user', { ...this.form, farmer_id: this.$route.params.farmer_id })
      aes.encrypt(tempJson_bin, this.commonKey, { name: 'AES-CBC', iv: iv })
        .then((encrypted) => {
          let iv_base64 = Buffer.from(iv).toString('base64')
          let encrypted_base64 = Buffer.from(encrypted).toString('base64')
          AWSAPI.addUser(encrypted_base64, iv_base64, this.commonKey_time)
            .then((res) => {
              if (this.checkAnswer(res, false)) {
                this.viewMessage("ユーザーを追加しました。", "success");
                this.select_user_id = "";
                this.user_name = "";
                this.email = "";
                this.user_edit = false;
              } else if (res.status == 403) {
                // 共通鍵再取得のため処理を抜ける
                this.apiRetry = true;
                this.generateKeys()
                return;
              }
              this.filterClear();
              this.setFilter();
              this.get_users_data();
            });
        });
    },
    update_user: async function () {
      // 更新
      let isUpdate = true;
      if (!this.itemCheckUser(isUpdate)) {
        return;
      }
      this.loading = true;
      await AWSAPI.updateUser(this.farmer_id, this.select_user_id, this.select_user_name, "", "", "", "", this.select_user_kind)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.viewMessage("ユーザーを更新しました。", "success");
            this.select_user_id = "";
            this.user_name = "";
            this.email = "";
            this.user_edit = false;
          }
          this.filterClear();
          this.setFilter();
          this.get_users_data();
        });
    },
    delete_user: async function () {
      // tableUserData
      let message = "ユーザー『" + this.select_user_name + "』を削除しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        AWSAPI.deleteUser(this.farmer_id, this.select_user_id)
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.viewMessage("ユーザーを削除しました。", "success");
            }
            this.select_user_id = "";
            this.user_edit = false;
            this.filterClear();
            this.setFilter();
            this.get_users_data();
          });
      }).catch(() => {
        return
      });
    },
    filterDialogOpen() {
      // フィルターダイアログ
      this.dialog_admin = this.filter_admin;
      this.dialog_helper = this.filter_helper;
      this.dialog_veterinarian = this.filter_veterinarian;
      this.dialog_demouser = this.filter_demouser;
      this.userSelectFilterDialog = true;
    },
    filterUpdate() {
      let envFilter = this.filter_admin ||
        this.filter_helper || this.filter_veterinarian || this.filter_demouser;
      if (envFilter) {
        this.icon_color = colorYellow;
      } else {
        this.icon_color = colorNormal;
      }
      if (!envFilter && this.search_text === "") {
        // 適用無し
        this.tableUserData = this.orgTableUserData;
      } else {
        // 適用あり
        this.tableUserData = [];
        for (let idx = 0; idx < this.orgTableUserData.length; idx++) {
          let tempEnabled = false;
          if (
            (this.filter_admin && this.orgTableUserData[idx]['kind'] === '管理者') ||
            (this.filter_helper && this.orgTableUserData[idx]['kind'] === '協力者') ||
            (this.filter_veterinarian && this.orgTableUserData[idx]['kind'] === '獣医') ||
            (this.filter_demouser && this.orgTableUserData[idx]['kind'] === 'デモユーザー') ||
            (!this.filter_admin && !this.filter_helper && !this.filter_veterinarian && !this.filter_demouser)
          ) {
            tempEnabled = true;
          }
          if (tempEnabled) {
            if (!(
              (this.search_text === "") ||
              (this.search_text !== "" && this.orgTableUserData[idx]['name'].indexOf(this.search_text) != -1) ||
              (this.search_text !== "" && this.orgTableUserData[idx]['email'].indexOf(this.search_text) != -1)
            )) {
              tempEnabled = false;
            }
          }
          if (tempEnabled) {
            this.tableUserData.push(this.orgTableUserData[idx]);
          }
        }
      }
      // アイテムソート指定
      let idx = this.sortIndex;
      if ((idx >= 0) && (this.sortLevel[idx] > 0)) {
        if (this.sortLevel[idx] == 1) {
          // 降順ソート
          this.tableUserData = sortBy(this.tableUserData, this.sortNames[idx]).reverse();
        } else {
          // 昇順ソート
          this.tableUserData = sortBy(this.tableUserData, this.sortNames[idx]);
        }
      }
    },
    filterDisable(filterNumber) {
      if (filterNumber == 1) { this.filter_admin = false }
      if (filterNumber == 2) { this.filter_helper = false }
      if (filterNumber == 3) { this.filter_veterinarian = false }
      if (filterNumber == 4) { this.filter_demouser = false }
      // フィルター再適用
      this.filterUpdate()
    },
    filterClear() {
      this.search_text = "";
      this.dialog_admin = false;
      this.dialog_helper = false;
      this.dialog_veterinarian = false;
      this.dialog_demouser = false;
      // フィルター再適用
      this.filterUpdate();
    },
    openDialog() {
      // フィルター設定内容の複写
      this.dialog_admin = this.filter_admin;
      this.dialog_helper = this.filter_helper;
      this.dialog_veterinarian = this.filter_veterinarian;
      this.dialog_demouser = this.filter_demouser;
      // ダイアログ・オープン
      this.userSelectFilterDialog = true;
    },
    setFilter() {
      // フィルター設定内容の反映
      this.filter_admin = this.dialog_admin;
      this.filter_helper = this.dialog_helper;
      this.filter_veterinarian = this.dialog_veterinarian;
      this.filter_demouser = this.dialog_demouser;
      // ダイアログ・クローズ
      this.userSelectFilterDialog = false;
      // フィルター再適用
      this.filterUpdate();
    },
    selectUser(val) {
      this.select_user_id = val['id'];
      this.select_user_name = val['name'];
      this.select_user_farmer_id = val['farmer'];
      this.select_user_kind = val['kind_id'];
      this.select_user_email = val['email'];
      this.save_user_name = this.select_user_name;
      this.save_user_farmer_id = this.select_user_farmer_id;
      this.save_user_kind = this.select_user_kind;
      this.save_user_email = this.select_user_email;
    },
    editNew() {
      this.select_user_id = "新規登録";
      this.select_user_name = "";
      this.saveUserName = "";
      this.select_user_farmer_id = this.userData['farmer']['farmer_id'];
      this.select_user_kind = 1;
      this.select_user_email = "";
      this.save_user_name = "";
      this.save_user_farmer_id = this.select_user_farmer_id;
      this.save_user_kind = 1;
      this.save_user_email = "";
      this.user_edit = true;
    },
    editCancel() {
      if (this.select_user_id === "新規登録") {
        this.select_user_id = "";
      }
      this.select_user_name = this.save_user_name;
      this.select_user_farmer_id = this.save_user_farmer_id;
      this.select_user_kind = this.save_user_kind;
      this.select_user_email = this.save_user_email;
      this.user_edit = false;
    },
    get_users_data: async function () {
      this.loading = true;
      this.usersData = {};
      this.usersDataEnc = {};
      await AWSAPI.getUsers(this.userData['farmer']['farmer_id'])
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.usersData = res['data']['data'];
            for (let idx = 0; idx < this.usersData.length; idx++) {
              let authIndex = this.getAuthLevel(this.usersData[idx])
              this.usersData[idx].user_type_name = this.user_kinds[authIndex]
              this.usersData[idx].user_type_id = authIndex
            }
            this.usersDataEnc = res['data']['encrypt'];
          }
        });
    },
    restore_param() {
      // パラメータ復元
      this.isAdmin = this.$store.state.userAdmin;
    },
    // ここから後ろは固定
    SetTableHeader(col_num) {
      // table headerの色変更
      var elements = document.getElementsByClassName('el-table__cell');
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.background = "#EEEEEC";
        if (i + 1 >= col_num) {
          // 指定されたカラム数で処理を抜ける
          break;
        }
      }
    },
    get_current_user: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getUserSp3()
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.userData = res['data']['data'][0];
          }
        });
    },
    get_id_token: async function () {
      try {
        const currentUser = await getCurrentUser();
        this.idToken = currentUser.idToken.jwtToken;
      } catch (e) {
        this.alertMessage("通知", ConstParam.relogin_message);
        this.$router.push('/login')
      }
    },
    viewMessage(message, status) {
      if (message === '') { return }
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status,
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    aesDecryptUsers(encrypt_base64, iv_base64) {
      let encrypt_bin = Buffer.from(encrypt_base64, "base64")
      let iv_bin = Buffer.from(iv_base64, "base64")
      aes.decrypt(encrypt_bin, this.commonKey, { name: 'AES-CBC', iv: iv_bin })
        .then((decrypted) => {
          let emails = JSON.parse(new TextDecoder().decode(decrypted))
          for (let idx = 0; idx < this.orgTableUserData.length; idx++) {
            const index = emails.findIndex(ema => ema.user_id === this.orgTableUserData[idx]['id']);
            if (index != -1) {
              this.orgTableUserData[idx]['email'] = emails[index]['email']
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    decryptUsers() {
      // 復号
      if (this.commonKey_time == 0) {
        // commonKey更新待ち
        this.decUsersRetry = true
      } else if (this.commonKey_time == this.usersDataEnc.created_at) {
        // 復号可
        let enc_data_base64 = this.usersDataEnc.data
        let iv_base64 = this.usersDataEnc.iv
        this.aesDecryptUsers(enc_data_base64, iv_base64)
      } else if (this.commonKey_time < this.usersDataEnc.created_at) {
        // 共通鍵要更新
        this.decUsersRetry = true
        this.getCommonKey(this.publicKey_base64)
      } else {
        // 要データ再取得(古い共通鍵で暗号化されている場合)
        this.alertMessage("通知", "メールアドレス一覧の取得に失敗しました。");
      }
    },
    getAuthLevel(userData) {
      let ret = 0
      if ('user_type' in userData && userData.user_type) {
        ret = userData.user_type
      }
      if (typeof (ret) === 'string') {
        ret = 0
      }
      return ret
    },
    getIsAdmin(authLevel) {
      let ret = true
      if (authLevel != 0) {
        ret = false
      }
      return ret
    }
  },
  watch: {
    userData: function () {
      if ('user_name' in this.userData) {
        this.viewUserName = this.userData['user_name'];
      }
      if ('farmer' in this.userData && 'farmer_name' in this.userData['farmer']) {
        this.viewFarmerName = this.userData['farmer']['farmer_name'];
      }
      if ('farmer' in this.userData && 'farmer_id' in this.userData['farmer']) {
        this.farmer_id = this.userData['farmer']['farmer_id'];
      }
      // ユーザー権限確認
      let tempUserType = this.getAuthLevel(this.userData)
      this.isAdmin = this.getIsAdmin(tempUserType)
      this.userType = tempUserType
      // パラメータ保存(権限)
      this.$store.commit('setUserAdmin', this.isAdmin);
      // 権限不足の場合
      if (!this.isAdmin) {
        this.$router.push('/')
      }
      // ユーザーデータ取得
      this.get_users_data();
    },
    usersData: function () {
      // ユーザー情報作成
      let tempTable = [];
      for (let idx = 0; idx < this.usersData.length; idx++) {
        let tempData = {
          "name": this.usersData[idx].user_name,
          "farmer": this.userData['farmer'].farmer_id,
          "kind": this.usersData[idx].user_type_name,
          "kind_id": this.usersData[idx].user_type_id,
          "email": '',
          "id": this.usersData[idx].user_id
        }
        tempTable.push(tempData);
      }
      this.tableUserData = tempTable;
      this.orgTableUserData = this.tableUserData;
      if (this.usersData.length > 0) {
        this.decryptUsers();
      }
      this.filterUpdate();
      this.loading = false;
    },
    commonKey: function () {
      if (this.decUsersRetry) {
        this.decUsersRetry = false;
        this.decryptUsers();
      }
      if (this.apiRetry) {
        this.apiRetry = false;
        this.add_user_sub();
      }
    },
  }
}
</script>

<style scoped>
.el-row {
  justify-content: left;
}

.font-bold {
  font-weight: bold;
}

.padding-left-2 {
  padding-left: 2em;
}
</style>
